module.exports = __webpack_public_path__ + "static/media/infographic.dbbfaf1d.jpg";